import { Injectable } from '@angular/core';

import { BillingsIndexComponent } from '../../components/billings/billings-index/billings-index.component';
import { BillingRecordTimeComponent } from '../../components/billings/billing-record-time/billing-record-time.component';
import { MatterAdministrationComponent } from '../../components/matters/matter-administration/matter-administration.component';
import { MatterHistoriesComponent } from '../../components/matters/matter-histories/matter-histories.component';
import { MatterShowComponent } from '../../components/matters/matter-show/matter-show.component';
import { MatterSidebarComponent } from '../../components/matters/matter-sidebar/matter-sidebar.component';

@Injectable()
export class MatterStoreService {
  billingsIndexComponent: BillingsIndexComponent | null;
  billingRecordTimeComponent: BillingRecordTimeComponent | null;
  documentEditor: boolean = false;
  documentUploader: boolean = false;
  is_matter_user: boolean = false;
  matterAdministrationComponent: MatterAdministrationComponent | null;
  matterHistoriesComponent: MatterHistoriesComponent | null;
  matterShowComponent: MatterShowComponent | null;
  matterSidebarComponent: MatterSidebarComponent | null;

  constructor() {}
}
